import { render, staticRenderFns } from "./ItemPlay.vue?vue&type=template&id=3e1265d9&scoped=true&"
import script from "./ItemPlay.vue?vue&type=script&lang=js&"
export * from "./ItemPlay.vue?vue&type=script&lang=js&"
import style0 from "./ItemPlay.vue?vue&type=style&index=0&id=3e1265d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1265d9",
  null
  
)

export default component.exports